import {
  string as yupString,
} from 'yup';

import InputFormik from '../../shared/forms/input/inputFormik.component';
import { required, maxLength, validateValueIsUnique } from '../../shared/forms/validators';

const validateBusinessCode = validateValueIsUnique({
  optionsKey: 'businessCodeOptions',
  message: 'Business Code already exists.',
  conditionFn: (option, selectedValue, context) =>
    option.value === selectedValue && option.businessCode !== context.parent.businessCode,
});

const schema = [
  {
    name: 'businessCode',
    component: InputFormik,
    meta: { label: 'Business Code', optionsKey: 'businessCodeOptions' },
    options: { disabledWhenEditing: true, yupType: yupString(),
      validationRules: [required, maxLength(6), validateBusinessCode] },
    additionalProps: { required: true },
  },
  {
    name: 'businessDescription',
    component: InputFormik,
    meta: { label: 'Business Description' },
    options: { yupType: yupString(), validationRules: [maxLength(50)] },
  },
  {
    name: 'source',
    component: InputFormik,
    meta: { label: 'Source' },
    options: { yupType: yupString(), validationRules: [maxLength(50)] },
  },
];

export default schema;
